import { Input as AntdInput } from 'antd';
import type { InputProps } from 'antd';
import React from 'react';

import { StyledInput, StyledPasswordInput, StyledTagInput, StyledTextArea } from './input.style';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const Input = (props: InputProps & React.RefAttributes<any>) => <StyledInput {...props} />;

Input.TextArea = StyledTextArea;

type PasswordPropsType = React.ComponentProps<typeof AntdInput.Password>;
export const InputPassword = (props: PasswordPropsType) => <StyledPasswordInput {...props} />;

export const TagInput = (props: InputProps) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <StyledTagInput {...props} mode='tags' open={false} showSearch={false} />
);
